module.exports = __webpack_public_path__ + "static/img/zhongwulian.5f13a47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhongwulian.png
// module id = YrdM
// module chunks = 1